import { Contact } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetContactResponse } from "../schema/GetContactResponse";
import { _contacts } from "@/_mock/_home";
import { mapContact } from "../../mappers/contacts/contactMapper";

export const getContact = async (): Promise<Contact> => {
  const client = ApiClient.getInstance()

  const response = await client.get<GetContactResponse>("home/contact")

  const mappedResponse = mapContact(response.data)

  return mappedResponse;

}